import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/Css/About.css";

const About = () => {

    const values = [
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
            ),
            title: 'Built by Agents, for Agents',
            description: 'We understand real estate because we\'ve lived it. Our team includes experienced agents who know the daily challenges you face.'
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
            ),
            title: 'Quality First',
            description: 'We don\'t cut corners. Every feature is thoughtfully designed and rigorously tested to ensure it truly helps you work better.'
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
            ),
            title: 'Your Data, Protected',
            description: 'We take security seriously. Your client information and transaction data are protected with enterprise-grade security.'
        },
        {
            icon: (
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </svg>
            ),
            title: 'Time is Money',
            description: 'We\'re obsessed with saving you time. Every feature is designed to automate tedious tasks so you can focus on selling.'
        }
    ];

    return (
        <div className="about-page">
            {/* Hero */}
            <section className="about-hero">
                <div className="container">
                    <span className="badge">About Us</span>
                    <h1 className="about-hero__title">
                        We're on a Mission to<br />
                        <span className="gradient-text">Transform Real Estate</span>
                    </h1>
                    <p className="about-hero__subtitle">
                        Deal to Close AI was born from a simple frustration: real estate professionals
                        spend too much time on paperwork and not enough time with clients.
                    </p>
                </div>
            </section>

            {/* Story */}
            <section className="about-story section">
                <div className="container">
                    <div className="about-story__content">
                        <h2 className="about-story__title">Our Story</h2>
                        <p>
                            In 2023, our founders — a top-producing agent and a tech entrepreneur —
                            sat down to solve a problem they both understood too well: the overwhelming
                            administrative burden of real estate transactions.
                        </p>
                        <p>
                            After countless late nights managing spreadsheets, chasing signatures, and
                            juggling deadlines, they asked: "What if AI could handle the paperwork so
                            agents could focus on what they do best — building relationships and closing deals?"
                        </p>
                        <p>
                            That question became Deal to Close AI. Today, we're helping hundreds of
                            real estate professionals automate up to 70% of their transaction workflow,
                            giving them back hours every week to grow their business.
                        </p>
                    </div>
                    <div className="about-story__visual">
                        <div className="about-story__image">
                            <div className="about-story__image-placeholder">
                                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.3">
                                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                    <polyline points="9 22 9 12 15 12 15 22" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Values */}
            <section className="about-values section">
                <div className="container">
                    <h2 className="section-title">Our Values</h2>
                    <p className="section-subtitle">
                        The principles that guide everything we build.
                    </p>
                    <div className="values__grid">
                        {values.map((value, index) => (
                            <div key={index} className="value-card">
                                <div className="value-card__icon">
                                    {value.icon}
                                </div>
                                <h3 className="value-card__title">{value.title}</h3>
                                <p className="value-card__description">{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section className="about-cta">
                <div className="container">
                    <h2 className="about-cta__title">Join Us on This Journey</h2>
                    <p className="about-cta__subtitle">
                        Be part of the future of real estate transaction management.
                    </p>
                    <div className="about-cta__buttons">
                        <Link to="/#" className="btn btn-primary btn-lg">
                            Get Started Free
                        </Link>
                        <Link to="/careers" className="btn btn-secondary btn-lg">
                            View Careers
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
